<!-- src/components/portafolio/ClinicaSalud.vue -->
<template>
  <div class="clinica-salud">
    <!-- Header con navegación REDISEÑADO -->
    <v-app-bar
      color="#006064"
      dark
      elevate-on-scroll
      flat
      height="64"
      class="clinica-salud__menu-bar"
    >
      <v-btn
        icon
        dark
        class="clinica-salud__back-btn hidden-sm-and-down"
        @click="$router.push('/portafolio')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-app-bar-nav-icon
        @click="drawer = true"
        class="hidden-md-and-up clinica-salud__nav-icon"
      ></v-app-bar-nav-icon>

      <div class="logo-wrapper">
        <v-icon class="logo-icon" size="28">mdi-hospital</v-icon>
        <span class="logo-text">CLÍNICA SALUD</span>
      </div>

      <v-spacer></v-spacer>

      <div class="nav-links d-none d-md-flex">
        <a href="#inicio" class="nav-link" @click.prevent="scrollToTop">Inicio</a>
        <a
          href="#servicios"
          class="nav-link"
          @click.prevent="scrollToSection('servicios')"
          >Servicios</a
        >
        <a
          href="#especialistas"
          class="nav-link"
          @click.prevent="scrollToSection('especialistas')"
          >Especialistas</a
        >
        <a href="#citas" class="nav-link" @click.prevent="scrollToSection('citas')"
          >Contacto</a
        >
        <a
          href="#citas"
          class="nav-link emergency-link"
          @click.prevent="scrollToSection('citas')"
        >
          <v-icon small class="mr-1">mdi-phone</v-icon>
          Emergencias
        </a>
        <a
          href="#citas"
          class="nav-link cta-link"
          @click.prevent="scrollToSection('citas')"
        >
          <v-icon small class="mr-1">mdi-calendar</v-icon>
          Agendar cita
        </a>
      </div>
    </v-app-bar>

    <!-- Drawer móvil -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      class="clinica-salud__drawer"
    >
      <v-list>
        <v-list-item class="clinica-salud__drawer-header">
          <v-list-item-content>
            <v-list-item-title class="headline white--text">Menú</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="drawer = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider class="white--text"></v-divider>
        <v-list-item
          class="clinica-salud__drawer-item"
          @click="
            drawer = false;
            scrollToTop();
          "
        >
          <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
          <v-list-item-content>Inicio</v-list-item-content>
        </v-list-item>
        <v-list-item
          class="clinica-salud__drawer-item"
          @click="
            drawer = false;
            scrollToSection('servicios');
          "
        >
          <v-list-item-icon><v-icon>mdi-stethoscope</v-icon></v-list-item-icon>
          <v-list-item-content>Servicios</v-list-item-content>
        </v-list-item>
        <v-list-item
          class="clinica-salud__drawer-item"
          @click="
            drawer = false;
            scrollToSection('especialistas');
          "
        >
          <v-list-item-icon><v-icon>mdi-doctor</v-icon></v-list-item-icon>
          <v-list-item-content>Especialistas</v-list-item-content>
        </v-list-item>
        <v-list-item
          class="clinica-salud__drawer-item"
          @click="
            drawer = false;
            scrollToSection('citas');
          "
        >
          <v-list-item-icon><v-icon>mdi-calendar</v-icon></v-list-item-icon>
          <v-list-item-content>Agendar cita</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Hero Section -->
    <v-parallax
      src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d"
      height="550"
    >
      <v-container fill-height>
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="12" md-8>
            <div class="hero-content">
              <v-chip label color="#00ACC1" text-color="white" class="mb-4" large>
                Atención médica 24/7
              </v-chip>
              <h1 class="display-3 font-weight-bold white--text mb-4">Clínica Salud</h1>
              <h2 class="headline white--text mb-6 font-weight-light">
                Tu salud, nuestra prioridad. Atención médica de calidad para toda la
                familia
              </h2>
              <v-row justify="center" class="clinica-salud__hero-buttons">
                <v-col cols="auto">
                  <v-btn
                    color="#00ACC1"
                    dark
                    x-large
                    rounded
                    elevation-10
                    @click="scrollToSection('citas')"
                  >
                    <v-icon left>mdi-calendar</v-icon>
                    Agendar cita online
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    outlined
                    dark
                    x-large
                    rounded
                    @click="scrollToSection('servicios')"
                  >
                    <v-icon left>mdi-information</v-icon>
                    Conocer servicios
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>

    <!-- Estadísticas -->
    <v-container class="mt-n8">
      <v-card elevation="10" class="stats-card">
        <v-container>
          <v-row>
            <v-col
              v-for="(stat, idx) in estadisticas"
              :key="idx"
              cols="6"
              md="3"
              class="text-center"
            >
              <div class="stat-item">
                <v-icon size="40" color="#00ACC1">{{ stat.icono }}</v-icon>
                <h3 class="display-1 font-weight-bold mt-2">{{ stat.valor }}</h3>
                <p class="subtitle-1 grey--text">{{ stat.label }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- Beneficios principales -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center clinica-salud__section-title">
          <h2 class="display-1 font-weight-bold mb-2">Por qué elegir Clínica Salud</h2>
          <p class="subtitle-1 grey--text clinica-salud__section-subtitle">
            Atención cercana, tecnología moderna y una experiencia de salud confiable.
          </p>
        </v-col>
      </v-row>
      <v-row class="mt-8">
        <v-col cols="12" sm="6" md="4">
          <v-card class="clinica-salud__why-card pa-6" elevation="4">
            <v-icon size="40" color="#00ACC1" class="clinica-salud__why-icon"
              >mdi-heart-pulse</v-icon
            >
            <h3 class="headline font-weight-bold mt-4">Atención humana</h3>
            <p class="grey--text mt-3">
              Equipo médico empático y dedicado que te acompaña en cada paso.
            </p>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card class="clinica-salud__why-card pa-6" elevation="4">
            <v-icon size="40" color="#006064" class="clinica-salud__why-icon"
              >mdi-flask</v-icon
            >
            <h3 class="headline font-weight-bold mt-4">Tecnología de punta</h3>
            <p class="grey--text mt-3">
              Diagnósticos rápidos y tratamientos seguros con equipos avanzados.
            </p>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card class="clinica-salud__why-card pa-6" elevation="4">
            <v-icon size="40" color="#4CAF50" class="clinica-salud__why-icon"
              >mdi-clock-outline</v-icon
            >
            <h3 class="headline font-weight-bold mt-4">Servicio 24/7</h3>
            <p class="grey--text mt-3">
              Respuesta inmediata y asistencia continua para urgencias y consultas.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Servicios médicos -->
    <v-container id="servicios" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center clinica-salud__section-title">
          <h2 class="display-1 font-weight-bold mb-2">Nuestros Servicios</h2>
          <p class="subtitle-1 grey--text clinica-salud__section-subtitle">
            Ofrecemos atención médica integral con tecnología de punta
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          v-for="(servicio, idx) in servicios"
          :key="idx"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="service-card"
              :class="{ 'service-card-hover': hover }"
              :style="{ borderTop: '4px solid ' + servicio.color }"
              @click="verServicio(servicio)"
            >
              <div class="service-icon">
                <v-icon size="48" :color="servicio.color">{{ servicio.icono }}</v-icon>
              </div>
              <v-card-title class="justify-center pt-4">
                {{ servicio.nombre }}
              </v-card-title>
              <v-card-text class="text-center">
                <p class="body-2 grey--text">{{ servicio.descripcion }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  block
                  :color="servicio.color"
                  dark
                  rounded
                  @click.stop="agendarCitaServicio(servicio)"
                >
                  <v-icon left>mdi-calendar</v-icon>
                  Agendar cita
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Especialistas médicos -->
    <v-container id="especialistas" class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center clinica-salud__section-title">
          <h2 class="display-1 font-weight-bold mb-2">Nuestros Especialistas</h2>
          <p class="subtitle-1 grey--text clinica-salud__section-subtitle">
            Médicos altamente calificados para tu bienestar
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          v-for="(doctor, idx) in doctores"
          :key="idx"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 4"
              class="doctor-card"
              :class="{ 'doctor-card-hover': hover }"
            >
              <v-avatar size="120" class="mt-6 mx-auto d-block">
                <v-img :src="doctor.avatar"></v-img>
              </v-avatar>
              <v-card-title class="justify-center pt-4">
                {{ doctor.nombre }}
              </v-card-title>
              <v-card-text class="text-center">
                <v-chip small :color="doctor.color" dark class="mb-2">
                  {{ doctor.especialidad }}
                </v-chip>
                <p class="body-2 grey--text mt-2">{{ doctor.descripcion }}</p>
                <div class="d-flex justify-center align-center mt-2">
                  <v-rating
                    v-model="doctor.rating"
                    readonly
                    dense
                    half-increments
                    color="#FFD700"
                    size="18"
                  ></v-rating>
                  <span class="ml-2 caption">({{ doctor.reviews }})</span>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  block
                  color="#00ACC1"
                  outlined
                  rounded
                  @click.stop="agendarCitaDoctor(doctor)"
                >
                  <v-icon left>mdi-calendar</v-icon>
                  Agendar cita
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- Instalaciones -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Nuestras Instalaciones</h2>
          <p class="subtitle-1 grey--text">
            Ambientes modernos y equipados para tu comodidad
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(img, idx) in instalaciones" :key="idx" cols="12" sm="6" md="3">
          <v-img :src="img" height="200" class="gallery-img" @click="openGallery(idx)">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="#00ACC1"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </v-container>

    <!-- Testimonios -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Opiniones de nuestros pacientes</h2>
          <p class="subtitle-1 grey--text">Lo que dicen quienes confían en nosotros</p>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col v-for="(testimonio, idx) in testimonios" :key="idx" cols="12" md="4">
          <v-card class="testimonial-card pa-4" elevation="3">
            <v-card-text>
              <v-icon color="#00ACC1" size="32" class="mb-2"
                >mdi-format-quote-open</v-icon
              >
              <p class="body-1 font-italic">"{{ testimonio.texto }}"</p>
              <div class="d-flex align-center mt-4">
                <v-avatar size="50">
                  <v-img :src="testimonio.avatar"></v-img>
                </v-avatar>
                <div class="ml-3">
                  <p class="mb-0 font-weight-bold">{{ testimonio.nombre }}</p>
                  <p class="caption grey--text mb-0">{{ testimonio.servicio }}</p>
                  <v-rating
                    :value="testimonio.rating"
                    readonly
                    dense
                    small
                    color="#FFD700"
                  ></v-rating>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Formulario de cita médica -->
    <v-container id="citas" class="mt-12">
      <v-card color="#E0F7FA" class="clinica-salud__form-card pa-8">
        <v-row>
          <v-col cols="12" md="6">
            <h2 class="display-1 font-weight-bold mb-4">Agenda tu cita médica</h2>
            <p class="subtitle-1 grey--text">
              Completa el formulario y uno de nuestros asesores te contactará para
              confirmar tu cita
            </p>

            <v-form ref="formCita" v-model="validCita" class="mt-6">
              <v-text-field
                v-model="cita.nombre"
                label="Nombre completo"
                outlined
                :rules="[(v) => !!v || 'Campo requerido']"
                prepend-inner-icon="mdi-account"
              ></v-text-field>

              <v-text-field
                v-model="cita.email"
                label="Correo electrónico"
                outlined
                type="email"
                :rules="[
                  (v) => !!v || 'Campo requerido',
                  (v) => /.+@.+\..+/.test(v) || 'Email inválido',
                ]"
                prepend-inner-icon="mdi-email"
              ></v-text-field>

              <v-text-field
                v-model="cita.telefono"
                label="Teléfono / Celular"
                outlined
                :rules="[(v) => !!v || 'Campo requerido']"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>

              <v-select
                v-model="cita.servicio"
                :items="servicios.map((s) => s.nombre)"
                label="Especialidad médica"
                outlined
                :rules="[(v) => !!v || 'Selecciona una especialidad']"
                prepend-inner-icon="mdi-stethoscope"
              ></v-select>

              <v-select
                v-model="cita.doctor"
                :items="doctores.map((d) => d.nombre)"
                label="Doctor preferido (opcional)"
                outlined
                clearable
                prepend-inner-icon="mdi-doctor"
              ></v-select>

              <v-text-field
                v-model="cita.fecha"
                label="Fecha preferida"
                type="date"
                outlined
                :min="minDate"
                :rules="[(v) => !!v || 'Selecciona una fecha']"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>

              <v-select
                v-model="cita.hora"
                :items="horas"
                label="Hora preferida"
                outlined
                :rules="[(v) => !!v || 'Selecciona una hora']"
                prepend-inner-icon="mdi-clock"
              ></v-select>

              <v-textarea
                v-model="cita.sintomas"
                label="Síntomas o motivo de consulta"
                outlined
                rows="3"
                :rules="[(v) => !!v || 'Campo requerido']"
                prepend-inner-icon="mdi-file-document"
              ></v-textarea>

              <v-checkbox
                v-model="cita.seguro"
                label="¿Cuentas con seguro médico?"
                color="#00ACC1"
              ></v-checkbox>

              <v-btn
                color="#00ACC1"
                dark
                x-large
                block
                rounded
                :disabled="!validCita"
                @click="enviarCita"
              >
                <v-icon left>mdi-calendar-check</v-icon>
                Confirmar cita
              </v-btn>
            </v-form>
          </v-col>

          <v-col cols="12" md="6">
            <v-img
              src="https://images.unsplash.com/photo-1579684385127-1ef15d508118"
              height="100%"
              class="rounded-lg"
            ></v-img>

            <div class="mt-4">
              <h3 class="title">Información de contacto</h3>
              <div class="mt-3">
                <p>
                  <v-icon small class="mr-2" color="#00ACC1">mdi-map-marker</v-icon>
                  Av. La Salud 789, San Isidro, Lima - Perú
                </p>
                <p>
                  <v-icon small class="mr-2" color="#00ACC1">mdi-phone</v-icon>
                  Central: +51 928 180 748
                </p>
                <p>
                  <v-icon small class="mr-2" color="#00ACC1">mdi-cellphone</v-icon>
                  Emergencias: 123-456
                </p>
                <p>
                  <v-icon small class="mr-2" color="#00ACC1">mdi-whatsapp</v-icon>
                  WhatsApp: +51 987 654 321
                </p>
                <p>
                  <v-icon small class="mr-2" color="#00ACC1">mdi-email</v-icon>
                  citas@clinicasalud.com
                </p>
              </div>

              <v-divider class="my-4"></v-divider>

              <h3 class="title">Horario de atención</h3>
              <div class="mt-3">
                <p><strong>Lunes a Viernes:</strong> 8:00 am - 8:00 pm</p>
                <p><strong>Sábados:</strong> 9:00 am - 5:00 pm</p>
                <p><strong>Domingos y feriados:</strong> Emergencias 24/7</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- Convenios -->
    <v-container class="mt-12">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="display-1 font-weight-bold mb-2">Aseguradoras con convenio</h2>
          <p class="subtitle-1 grey--text">
            Trabajamos con las principales aseguradoras del país
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-8" align="center">
        <v-col v-for="(seguro, idx) in seguros" :key="idx" cols="6" sm="4" md="2">
          <v-card class="seguro-card text-center pa-3" elevation="2">
            <v-img :src="seguro.logo" height="60" contain></v-img>
            <p class="mt-2 mb-0 caption font-weight-bold">{{ seguro.nombre }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Footer -->
    <v-footer dark class="clinica-salud__footer mt-12 pa-10">
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-icon large class="mb-2">mdi-hospital</v-icon>
            <h3 class="title">Clínica Salud</h3>
            <p class="caption mt-2">Cuidando tu salud con excelencia y calidez humana</p>
            <div class="mt-3">
              <v-btn icon dark class="mr-2">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn icon dark class="mr-2">
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
              <v-btn icon dark class="mr-2">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn icon dark>
                <v-icon>mdi-youtube</v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <h3>Servicios</h3>
            <v-list dense dark>
              <v-list-item v-for="serv in servicios.slice(0, 4)" :key="serv.nombre">
                <v-list-item-content class="caption">{{
                  serv.nombre
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="3">
            <h3>Enlaces útiles</h3>
            <v-list dense dark>
              <v-list-item @click="scrollToTop">
                <v-list-item-content>Inicio</v-list-item-content>
              </v-list-item>
              <v-list-item @click="scrollToSection('servicios')">
                <v-list-item-content>Servicios</v-list-item-content>
              </v-list-item>
              <v-list-item @click="scrollToSection('citas')">
                <v-list-item-content>Agendar cita</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Trabaja con nosotros</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="3">
            <h3>Boletín informativo</h3>
            <p class="caption">Recibe consejos de salud y promociones</p>
            <v-text-field
              v-model="newsletterEmail"
              placeholder="Tu correo electrónico"
              outlined
              dense
              dark
              append-icon="mdi-email-send"
              @click:append="suscribirNewsletter"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <div class="text-center caption">
          © 2024 Clínica Salud - Todos los derechos reservados. <br />
          Tu salud, nuestra prioridad.
        </div>
      </v-container>
    </v-footer>

    <!-- Dialog de confirmación -->
    <v-dialog v-model="dialogConfirmacion" max-width="400">
      <v-card>
        <v-card-title class="headline success--text">
          <v-icon left color="success" large>mdi-check-circle</v-icon>
          ¡Cita agendada!
        </v-card-title>
        <v-card-text>
          Gracias {{ cita.nombre }}. Hemos recibido tu solicitud de cita para el día
          {{ cita.fecha }} a las {{ cita.hora }}. <br /><br />
          Te contactaremos a la brevedad para confirmar tu cita.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00ACC1" text @click="dialogConfirmacion = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Lightbox para galería -->
    <v-dialog v-model="galleryDialog" max-width="800">
      <v-card>
        <v-img :src="instalaciones[currentGalleryIndex]" height="500" contain>
          <v-btn absolute top right fab small dark @click="galleryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-img>
        <v-card-actions>
          <v-btn :disabled="currentGalleryIndex === 0" @click="currentGalleryIndex--">
            <v-icon>mdi-chevron-left</v-icon> Anterior
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="currentGalleryIndex === instalaciones.length - 1"
            @click="currentGalleryIndex++"
          >
            Siguiente <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ClinicaSalud",
  data() {
    return {
      drawer: false,
      validCita: false,
      dialogConfirmacion: false,
      galleryDialog: false,
      currentGalleryIndex: 0,
      newsletterEmail: "",
      horas: [
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
      ],
      estadisticas: [
        { icono: "mdi-account-group", valor: "50,000+", label: "Pacientes atendidos" },
        { icono: "mdi-stethoscope", valor: "30+", label: "Especialidades" },
        { icono: "mdi-doctor", valor: "80+", label: "Médicos especialistas" },
        { icono: "mdi-star", valor: "4.9", label: "Calificación promedio" },
      ],
      servicios: [
        {
          nombre: "Medicina General",
          icono: "mdi-stethoscope",
          color: "#00ACC1",
          descripcion: "Atención médica integral para toda la familia",
        },
        {
          nombre: "Pediatría",
          icono: "mdi-baby",
          color: "#4CAF50",
          descripcion: "Cuidado especializado para niños y adolescentes",
        },
        {
          nombre: "Ginecología",
          icono: "mdi-female",
          color: "#E91E63",
          descripcion: "Salud femenina y control prenatal",
        },
        {
          nombre: "Cardiología",
          icono: "mdi-heart",
          color: "#F44336",
          descripcion: "Diagnóstico y tratamiento de enfermedades cardíacas",
        },
        {
          nombre: "Traumatología",
          icono: "mdi-bone",
          color: "#FF9800",
          descripcion: "Tratamiento de lesiones óseas y musculares",
        },
        {
          nombre: "Odontología",
          icono: "mdi-tooth",
          color: "#9C27B0",
          descripcion: "Servicios dentales y ortodoncia",
        },
        {
          nombre: "Dermatología",
          icono: "mdi-face",
          color: "#795548",
          descripcion: "Cuidado de la piel y tratamientos estéticos",
        },
        {
          nombre: "Oftalmología",
          icono: "mdi-eye",
          color: "#2196F3",
          descripcion: "Exámenes visuales y cirugía ocular",
        },
      ],
      doctores: [
        {
          nombre: "Dr. Carlos Ramírez",
          especialidad: "Cardiología",
          color: "#F44336",
          rating: 4.9,
          reviews: 234,
          descripcion:
            "Especialista en enfermedades cardiovasculares con 15 años de experiencia",
          avatar: "https://randomuser.me/api/portraits/men/1.jpg",
        },
        {
          nombre: "Dra. Ana Gutiérrez",
          especialidad: "Pediatría",
          color: "#4CAF50",
          rating: 4.8,
          reviews: 187,
          descripcion: "Atención cálida y profesional para tus hijos",
          avatar: "https://randomuser.me/api/portraits/women/2.jpg",
        },
        {
          nombre: "Dr. Javier Mendoza",
          especialidad: "Traumatología",
          color: "#FF9800",
          rating: 4.9,
          reviews: 156,
          descripcion: "Especialista en lesiones deportivas y cirugía ortopédica",
          avatar: "https://randomuser.me/api/portraits/men/3.jpg",
        },
        {
          nombre: "Dra. Lucía Fernández",
          especialidad: "Ginecología",
          color: "#E91E63",
          rating: 4.9,
          reviews: 203,
          descripcion: "Atención integral para la salud de la mujer",
          avatar: "https://randomuser.me/api/portraits/women/4.jpg",
        },
      ],
      instalaciones: [
        "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d",
        "https://images.unsplash.com/photo-1579684385127-1ef15d508118",
        "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d",
        "https://images.unsplash.com/photo-1579684385127-1ef15d508118",
      ],
      testimonios: [
        {
          nombre: "María Pérez",
          texto:
            "Excelente atención médica y profesionalismo. El Dr. Ramírez me salvó la vida con su diagnóstico oportuno.",
          rating: 5,
          servicio: "Cardiología",
          avatar: "https://randomuser.me/api/portraits/women/1.jpg",
        },
        {
          nombre: "Juan Torres",
          texto:
            "La clínica cuenta con equipos modernos y personal muy amable. Mi hijo recibió la mejor atención en pediatría.",
          rating: 5,
          servicio: "Pediatría",
          avatar: "https://randomuser.me/api/portraits/men/2.jpg",
        },
        {
          nombre: "Carmen Rojas",
          texto:
            "Me operaron de la rodilla y la recuperación fue excelente. Totalmente recomendado.",
          rating: 5,
          servicio: "Traumatología",
          avatar: "https://randomuser.me/api/portraits/women/3.jpg",
        },
      ],
      seguros: [
        {
          nombre: "Pacífico",
          logo: "https://via.placeholder.com/100x60/00ACC1/FFFFFF?text=Pac%C3%ADfico",
        },
        {
          nombre: "Rímac",
          logo: "https://via.placeholder.com/100x60/00ACC1/FFFFFF?text=R%C3%ADmac",
        },
        {
          nombre: "Mapfre",
          logo: "https://via.placeholder.com/100x60/00ACC1/FFFFFF?text=Mapfre",
        },
        {
          nombre: "Sanitas",
          logo: "https://via.placeholder.com/100x60/00ACC1/FFFFFF?text=Sanitas",
        },
        {
          nombre: "La Positiva",
          logo: "https://via.placeholder.com/100x60/00ACC1/FFFFFF?text=Positiva",
        },
        {
          nombre: "Salud Total",
          logo: "https://via.placeholder.com/100x60/00ACC1/FFFFFF?text=Salud",
        },
      ],
      cita: {
        nombre: "",
        email: "",
        telefono: "",
        servicio: "",
        doctor: "",
        fecha: "",
        hora: "",
        sintomas: "",
        seguro: false,
      },
    };
  },
  computed: {
    minDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    verServicio(servicio) {
      alert(`Más información sobre: ${servicio.nombre}`);
    },
    agendarCitaServicio(servicio) {
      this.cita.servicio = servicio.nombre;
      this.scrollToSection("citas");
    },
    agendarCitaDoctor(doctor) {
      this.cita.doctor = doctor.nombre;
      this.scrollToSection("citas");
    },
    openGallery(index) {
      this.currentGalleryIndex = index;
      this.galleryDialog = true;
    },
    enviarCita() {
      if (this.$refs.formCita.validate()) {
        this.dialogConfirmacion = true;
        console.log("Cita enviada:", this.cita);

        setTimeout(() => {
          this.cita = {
            nombre: "",
            email: "",
            telefono: "",
            servicio: "",
            doctor: "",
            fecha: "",
            hora: "",
            sintomas: "",
            seguro: false,
          };
          this.$refs.formCita.reset();
        }, 2000);
      }
    },
    suscribirNewsletter() {
      if (this.newsletterEmail && /.+@.+\..+/.test(this.newsletterEmail)) {
        alert("¡Gracias por suscribirte! Recibirás consejos de salud.");
        this.newsletterEmail = "";
      } else {
        alert("Por favor ingresa un email válido");
      }
    },
  },
};
</script>

<style scoped>
.clinica-salud {
  background: linear-gradient(180deg, #e7f4f8 0%, #f5f5f5 70%);
  min-height: 100vh;
  color: #102027;
}

/* ========== MENÚ REDISEÑADO ========== */
.clinica-salud__menu-bar {
  background: rgba(0, 96, 100, 0.95) !important;
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08) !important;
  border-bottom: 1px solid rgba(0, 172, 193, 0.3);
  height: 64px !important;
  transition: all 0.3s ease;
}

.clinica-salud__menu-bar.v-app-bar--is-scrolled {
  background: rgba(0, 96, 100, 0.98) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.clinica-salud__menu-bar .v-toolbar__content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px !important;
}

/* Logo */
.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.logo-icon {
  color: #00acc1;
  filter: drop-shadow(0 2px 4px rgba(0, 172, 193, 0.3));
}

.logo-text {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  background: linear-gradient(135deg, #fff, #80deea);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

/* Navegación links */
.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-link {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
  font-size: 0.85rem;
  padding: 8px 16px;
  border-radius: 32px;
  transition: all 0.2s ease;
  letter-spacing: 0.3px;
  cursor: pointer;
}

.nav-link:hover {
  color: #00acc1;
  background: rgba(0, 172, 193, 0.12);
}

/* Link de emergencias - estilo destacado */
.emergency-link {
  background: rgba(244, 67, 54, 0.12);
  border: 1px solid rgba(244, 67, 54, 0.35);
}

.emergency-link:hover {
  background: #f44336;
  color: white !important;
  border-color: #f44336;
}

/* Link CTA (Agendar cita) */
.cta-link {
  background: linear-gradient(135deg, #00acc1, #00838f);
  color: white !important;
  margin-left: 8px;
}

.cta-link:hover {
  background: linear-gradient(135deg, #00838f, #006064);
  transform: translateY(-1px);
}

/* Botón back */
.clinica-salud__back-btn {
  color: white !important;
  margin-right: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 40px !important;
}

/* Drawer móvil mejorado */
.clinica-salud__drawer {
  background: linear-gradient(180deg, #00545a 0%, #006064 100%);
  color: white;
}

.clinica-salud__drawer-header {
  padding-top: 20px;
  padding-bottom: 16px;
}

.clinica-salud__drawer-item {
  border-radius: 16px;
  margin: 6px 12px;
  transition: background 0.2s ease;
}

.clinica-salud__drawer-item:hover {
  background: rgba(0, 172, 193, 0.3);
}

.clinica-salud__drawer-item .v-list-item-content {
  color: #ffffff;
}

.clinica-salud__drawer-item .v-list-item-icon {
  color: #00acc1;
}

/* ========== RESTO DE ESTILOS (mantener igual) ========== */
.clinica-salud__back-btn {
  z-index: 2200;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.16);
}

.hero-content {
  background: rgba(0, 0, 0, 0.42);
  padding: 40px;
  border-radius: 24px;
  backdrop-filter: blur(10px);
}

.hero-content h1,
.hero-content h2 {
  text-shadow: 0 14px 35px rgba(0, 0, 0, 0.4);
}

.clinica-salud__section-title h2 {
  letter-spacing: -0.03em;
}

.clinica-salud__section-subtitle {
  max-width: 720px;
  margin: 0 auto;
  color: rgba(16, 32, 39, 0.72);
}

.clinica-salud__hero-buttons .v-btn {
  min-width: 220px;
}

.clinica-salud__why-card {
  border-radius: 24px;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.clinica-salud__why-icon {
  background: rgba(0, 172, 193, 0.12);
  border-radius: 16px;
  padding: 12px;
}

.clinica-salud__form-card {
  border-radius: 28px;
  box-shadow: 0 24px 70px rgba(16, 32, 39, 0.1);
}

.clinica-salud__footer {
  background: linear-gradient(135deg, #00545a 0%, #006064 100%);
}

.stats-card {
  margin-top: -40px;
  background: white;
  border-radius: 24px;
  position: relative;
  z-index: 10;
  box-shadow: 0 20px 40px rgba(16, 32, 39, 0.08);
}

.stat-item {
  padding: 15px;
}

.service-card {
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 20px;
  height: 100%;
  text-align: center;
}

.service-card-hover {
  transform: translateY(-10px);
  box-shadow: 0 24px 60px rgba(16, 32, 39, 0.12);
}

.service-icon {
  margin-top: 24px;
}

.doctor-card {
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 20px;
  height: 100%;
  text-align: center;
}

.doctor-card-hover {
  transform: translateY(-10px);
  box-shadow: 0 24px 60px rgba(16, 32, 39, 0.12);
}

.gallery-img {
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 10px;
  overflow: hidden;
}

.gallery-img:hover {
  transform: scale(1.05);
}

.testimonial-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 15px;
}

.testimonial-card:hover {
  transform: translateY(-5px);
}

.seguro-card {
  transition: transform 0.3s ease;
  cursor: pointer;
}

.seguro-card:hover {
  transform: translateY(-3px);
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.service-card,
.doctor-card,
.testimonial-card {
  animation: fadeIn 0.6s ease;
}

/* Responsive */
@media (max-width: 960px) {
  .clinica-salud__menu-bar .v-toolbar__content {
    padding: 0 16px;
  }
}

@media (max-width: 600px) {
  .display-3 {
    font-size: 2rem !important;
  }

  .display-1 {
    font-size: 1.8rem !important;
  }

  .hero-content {
    padding: 20px;
  }

  .stats-card {
    margin-top: -20px;
  }

  .service-card,
  .doctor-card {
    margin-bottom: 16px;
  }

  .logo-text {
    font-size: 0.8rem;
    letter-spacing: 1px;
  }
}

/* Scroll personalizado */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #00acc1;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #00838f;
}
</style>
